export default "__VITE_ASSET__DQfP7ymW__"